<template>
  <span>
    <span v-for="item in instance.list" :key="item.key">
      <a-divider v-if="item.divider" type="vertical" />
      <a @click="actionCb(item.cb, scope.scope)">{{item.name}}</a>
    </span>
  </span>
</template>

<script>
export default {
  props: {
    instance: Object,
    scope: Object // text, index, scope
  },
  data() {
    return {

    }
  },
  methods: {
    actionCb(cb, row) {
      this.$emit('actionClick', { cb, row })
    }
  }
}
</script>
